import { render, staticRenderFns } from "./UserPass.vue?vue&type=template&id=6dd34c69&scoped=true"
import script from "./UserPass.vue?vue&type=script&lang=js"
export * from "./UserPass.vue?vue&type=script&lang=js"
import style0 from "./UserPass.vue?vue&type=style&index=0&id=6dd34c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd34c69",
  null
  
)

export default component.exports